module.exports = __webpack_public_path__ + "img/C-suite_bc.513b98ba.svg";